import type { AppRouteRecordRaw } from '@/types/router'

// 国际环境路由配置 - 改为懒加载模式
async function loadWWRoutes(): Promise<AppRouteRecordRaw[]> {
  // 并行懒加载所有路由模块，避免静态导入导致的依赖预加载
  const [
    { commonRoutes },
    { activityRoutes },
    { posterRoutes },
    { shareRoutes },
    { specificRoutes }
  ] = await Promise.all([
    import('@/router/routes/common'),
    import('@/router/routes/activity'),
    import('@/router/routes/poster'),
    import('@/router/routes/share'),
    import('@/router/routes/specific')
  ])

  return [
    ...commonRoutes,
    ...activityRoutes,
    ...posterRoutes,
    ...shareRoutes,
    ...specificRoutes
  ]
}

// 导出懒加载函数
export const wwRoutes = loadWWRoutes

export default loadWWRoutes